import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchTechTopics } from "../lib/api";
import { Icon } from "./shared";
import { ArrowUpRight } from "lucide-react";

export default function TechDepth() {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTechTopics()
      .then((d) => setTopics(d))
      .catch(() => setTopics([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="tech" className="nst-light py-24 lg:py-32">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <span className="pill-label">Tech Depth</span>
            <h2 className="mt-6 text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#0A1F47] leading-[1.05]">
              Built on Real Systems, <br />
              <span className="text-[#2E6BF6]">Not Buzzwords</span>
            </h2>
          </div>
          <p className="text-[#0A1F47]/70 text-base lg:text-lg max-w-md">
            We design and operate platforms using proven technologies and modern architectural patterns.
          </p>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-32 bg-white/60 rounded-2xl animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {topics.map((t) => (
              <Link
                key={t.slug}
                to={`/tech/${t.slug}`}
                className="group bg-white border border-[#E2E8F4] rounded-2xl p-7 card-lift hover:border-[#2E6BF6]/50 flex items-start gap-5"
              >
                <div className="w-12 h-12 rounded-xl bg-[#EDF1FB] flex items-center justify-center flex-shrink-0 group-hover:bg-[#0A1F47] transition-colors">
                  <Icon name={t.icon} className="w-5 h-5 text-[#2E6BF6] group-hover:text-white transition-colors" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-bold text-[#0A1F47]">{t.name}</h3>
                    <ArrowUpRight className="w-4 h-4 text-[#0A1F47]/40 group-hover:text-[#2E6BF6] transition-colors" />
                  </div>
                  <p className="text-sm text-[#0A1F47]/65 mt-1 leading-relaxed">{t.short_desc}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
